import convert from "convert-units";
import get from "lodash/get";
import omit from "lodash/omit";
import round from "lodash/round";
import React from "react";
import { RillContext } from "../../rill/RillReact/share/base";
import escapeName from "../../utils/escape-form-name";

const numberReg = /[+-]?(\d+(\.\d*)?)?/;
const notNumberReg = /[^+\-.0-9]/g;

class UnitInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
  }

  UNSAFE_componentWillReceiveProps(next) {
    const { units } = get(this.props, "units", false)
      ? this.props
      : this.context.locals;
    const { defaultValue, metric } = next;
    if (defaultValue !== this.props.defaultValue) {
      const { input } = this.refs;
      input.defaultValue = round(
        convert(defaultValue).from(metric).to(next[units]),
        2
      );
      delete input.value;
    }
  }

  cleanNumber({ target }) {
    if (target.value === "" || target.value == null) return;
    const value = target.value.replace(notNumberReg, "");
    const match = (value.match(numberReg) || [])[0];
    if (target.value !== match) target.value = match;
  }

  render() {
    const { units } = get(this.props, "units", false)
      ? this.props
      : this.context.locals;
    const { name, defaultValue, metric, imperial, unitsTabIndex } = this.props;
    const onProgramEditor = Boolean(this.props.onProgramEditor);
    const value = !this.props.needToRound
      ? defaultValue &&
        round(convert(defaultValue).from(metric).to(this.props[units]), 2)
      : defaultValue &&
        round(convert(defaultValue).from(metric).to(this.props[units]), 0);

    const path = escapeName(name);
    const handleUnitChange = this.props.handleUnitChange;

    return (
      <div className="unit-input">
        <input
          ref="input"
          className="text-input"
          inputMode="numeric"
          pattern="-?\d+(\.\d+)?"
          data-name={path}
          {...omit(this.props, [
            "metric",
            "imperial",
            "handleUnitChange",
            "onProgramEditor",
            "units",
            "needToRound",
            "unitsTabIndex",
          ])}
          onChange={this.cleanNumber}
          defaultValue={value}
        />

        <div className="units-toggle">
          <input
            type="hidden"
            name={`${onProgramEditor ? "" : "_"}units[${path}][metric]`}
            value={metric}
          />

          <input
            type="hidden"
            name={`_units[${path}][imperial]`}
            value={imperial}
          />

          <label className={units === "metric" ? "active" : ""}>
            <input
              ref="metric"
              type="radio"
              name={`${onProgramEditor ? "" : "_"}units[${path}][type]`}
              key={this.props.units}
              checked={units === "metric"}
              value="metric"
              tabIndex={unitsTabIndex}
              onChange={handleUnitChange}
            />
            <b>{metric}</b>
          </label>

          <label className={units !== "metric" ? "active" : ""}>
            <input
              ref="imperial"
              type="radio"
              name={`${onProgramEditor ? "" : "_"}units[${path}][type]`}
              key={this.props.units}
              checked={units !== "metric"}
              value="imperial"
              tabIndex={unitsTabIndex}
              onChange={handleUnitChange}
            />
            <b>{imperial}</b>
          </label>
        </div>
      </div>
    );
  }
}

UnitInput.contextType = RillContext;

export default UnitInput;
